import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components
import Dashboard from './components/Dashboard';
import UsersList from './components/UsersList';
import UserDetail from './components/UserDetail';
import ProjectsList from './components/ProjectsList';
import ProjectDetail from './components/ProjectDetail';
import SubscriptionsList from './components/SubscriptionsList';
import LandingPageSubmissions from './components/LandingPageSubmissions';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import RedirectHandler from './components/RedirectHandler';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <RedirectHandler />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="users" element={<UsersList />} />
              <Route path="users/:userId" element={<UserDetail />} />
              <Route path="projects" element={<ProjectsList />} />
              <Route path="projects/:projectId" element={<ProjectDetail />} />
              <Route path="subscriptions" element={<SubscriptionsList />} />
              <Route path="landing-submissions" element={<LandingPageSubmissions />} />
            </Route>
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
